import { googleMapUrl } from 'Features/bizgainOnboarding/constants';
import moment from 'moment';
import { weekDays } from '../constants';

export class GoogleMapHelper {
  mapInitalize(mapElement) {
    return new Promise((resolve) => {
      window.initMap = function() {
        let googleMapObj = {};
        const card = document.getElementById('pac-card');
        googleMapObj.map = new google.maps.Map(mapElement, {
          center: { lat: 37.09, lng: -95.712 },
          zoom: 10,
          gestureHandling: 'cooperative',
          streetViewControl: false,
          fullscreenControl: false,
          mapTypeControl: false
        });
        googleMapObj.map.controls[google.maps.ControlPosition.TOP_RIGHT].push(card);
        googleMapObj.sessionToken = new google.maps.places.AutocompleteSessionToken();
        googleMapObj.service = new window.google.maps.places.AutocompleteService();
        resolve(googleMapObj);
      };
      let scriptId = 'google-maps';
      if (document.getElementById(scriptId)) {
        window.initMap();
        return;
      }
      let script = document.createElement('script');
      script.id = scriptId
      script.src = `${googleMapUrl}${process.env.VUE_APP_GOOGLE_API_KEY}&callback=initMap`;
      script.async = true;
      document.head.appendChild(script);
    });
  }

  getGoogleMapSuggesstion(predictions, status) {
    let searchResults = [];
    if (status !== window.google.maps.places.PlacesServiceStatus.OK) {
      searchResults = []
      return
    }
    for (let i = 0; i < predictions.length; i++) {
      let prediction = {};
      prediction.text = predictions[i].description;
      prediction.value = predictions[i].place_id;
      prediction.shortText = predictions[i].structured_formatting && predictions[i].structured_formatting.main_text;
      searchResults.push(prediction);
    }
    return searchResults;
  }

  getGoogleMapPlaceDetails(placeId, sessionToken, mapObject, showMap = false) {
    if (placeId && sessionToken && mapObject) {
      const request = {
        placeId: placeId,
        fields: ['name', 'address_components', 'formatted_address', 'place_id', 'geometry', 'url', 'international_phone_number', 'opening_hours', 'website', 'types', 'photos', 'reviews'],
        sessionToken: sessionToken
      };
      const placeService = new window.google.maps.places.PlacesService(mapObject);
      return new Promise((resolve) => {
        let placeDetails = {};
        placeService.getDetails(request, (place, status) => {
          if (
            status === window.google.maps.places.PlacesServiceStatus.OK &&
            place &&
            place.geometry &&
            place.geometry.location
          ) {
            if (showMap) {
              const infoWindow = new window.google.maps.InfoWindow();
              const marker = new window.google.maps.Marker({
                map: mapObject,
                position: place.geometry.location,
                anchorPoint: new google.maps.Point(0, -29),
                sessionToken: sessionToken,
                animation: window.google.maps.Animation.DROP
              });

              placeDetails.marker = marker;

              if (place.geometry.viewport) {
                mapObject.fitBounds(place.geometry.viewport);
              } else {
                mapObject.setCenter(place.geometry.location);
              }
              mapObject.setZoom(10);
              marker.setPosition(place.geometry.location);
              marker.setVisible(true);
              window.google.maps.event.addListener(marker, 'click', function () {
                infoWindow.setContent(
                  '<div><strong>' +
                    place.name +
                    '</strong><br>' +
                    place.formatted_address +
                    '</div>'
                );
                infoWindow.open(mapObject, this);
              });
            }

            let addressComponents = []
            if (place && Array.isArray(place.address_components) && place.address_components.length > 0) {
              place.address_components.forEach(addressComponent => {
                addressComponents.push({
                  longName: addressComponent.long_name,
                  shortName: addressComponent.short_name,
                  types: addressComponent.types
                });
              });
            }
            placeDetails.googlePlaceDetails = {
              placeId: place.place_id,
              location: {
                latitude: place.geometry.location.lat(),
                longitude: place.geometry.location.lng()
              },
              internationalPhoneNumber: place.international_phone_number,
              name: place.name,
              hours: place.opening_hours && JSON.parse(JSON.stringify(place.opening_hours)),
              mapUrl: place.url,
              website: place.website,
              address: place.formatted_address,
              categories: place.types,
              addressComponents,
              photos: place.photos,
              reviews: place.reviews
            }
          }
          placeDetails.sessionToken = new window.google.maps.places.AutocompleteSessionToken();
          resolve(placeDetails);
        });
      })
    }
  }

  getGoogleCurrentLocationDetails() {
    return new Promise(async (resolve, reject) => {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            const pos = {
              lat: position.coords.latitude,
              lng: position.coords.longitude
            };
            let request = {
              location: new window.google.maps.LatLng(pos.lat, pos.lng)
            }
            this.getGeoCodeData(request).then((response) => {
              resolve(response);
            });
          },
          () => {
            // Failed to fetch current location.
            reject(true);
          }
        )
      } else {
        // browser doesn't support geo location.
        reject(false);
      }
    })
  }

  getGeoCodeData(request) {
    return new Promise((resolve) => {
      const geocoder = new window.google.maps.Geocoder();
      geocoder.geocode(request, (results, status) => {
        if (status == google.maps.GeocoderStatus.OK) {
          if (results && Array.isArray(results) && results.length > 0) {
            let currentLocation = this.getLocationDetails(results[0]);
            if (currentLocation) {
              resolve(currentLocation);
            }
          }
        }
        resolve();
      });
    })
  }

  getLocationDetails(currentLocationDetails) {
    let currentLocation = {};
    if (currentLocationDetails) {
      if (currentLocationDetails.address_components &&
        Array.isArray(currentLocationDetails.address_components) &&
        currentLocationDetails.address_components.length > 0
      ) {
        let premise = null, streetNumber = null, route = null, sublocalityLevel3 = null, sublocalityLevel2 = null;
        currentLocationDetails.address_components.forEach(addressComponent => {
          if (addressComponent.types.includes('postal_code')) {
            currentLocation.postalCode = addressComponent.long_name;
          }
          if (addressComponent.types.includes('neighborhood')) {
            currentLocation.areaName = addressComponent.long_name;
          }
          if (addressComponent.types.includes('sublocality_level_3')) {
            currentLocation.areaName = addressComponent.long_name;
          }
          if (addressComponent.types.includes('sublocality_level_2')) {
            currentLocation.areaName = addressComponent.long_name;
          }
          if (addressComponent.types.includes('sublocality_level_1')) {
            currentLocation.areaName = addressComponent.long_name;
          }
          if (addressComponent.types.includes('administrative_area_level_3')) {
            currentLocation.city = addressComponent.long_name;
          }
          if (addressComponent.types.includes('administrative_area_level_2')) {
            currentLocation.city = addressComponent.long_name;
          }
          if (addressComponent.types.includes('locality')) {
            currentLocation.city = addressComponent.long_name;
          }
          if (addressComponent.types.includes('administrative_area_level_1')) {
            currentLocation.state = addressComponent.long_name;
          }
          if (addressComponent.types.includes('street_number')) {
            streetNumber = addressComponent.long_name;
          }
          if (addressComponent.types.includes('route')) {
            route = addressComponent.long_name;
          }
          if (addressComponent.types.includes('premise')) {
            premise = addressComponent.long_name;
          }
          if (addressComponent.types.includes('country')) {
            currentLocation.country = addressComponent.long_name;
            currentLocation.countryCode = addressComponent.short_name;
          }
        });
        let street = '';
        if (premise) {
          street += premise + ', '
        }
        if (streetNumber) {
          street +=  streetNumber + ', '
        }
        if (route) {
          street += route + ', '
        }
        if (sublocalityLevel3) {
          street += sublocalityLevel3 + ', '
        }
        if (sublocalityLevel2) {
          street += sublocalityLevel2
        }
        currentLocation.addressLine = street.trim();
      }
      if (currentLocationDetails.geometry && currentLocationDetails.geometry.location) {
        currentLocation.latitude = currentLocationDetails.geometry.location.lat(),
        currentLocation.longitude = currentLocationDetails.geometry.location.lng()
      }
    }
    return currentLocation;
  }

  drawCircle(mapObject, latitude, longitude, radius, color, strokeOpacity = 0.8, strokeWeight = 2, fillOpacity = 0.35) {
    return new window.google.maps.Circle({
      strokeColor: color,
      strokeOpacity: strokeOpacity,
      strokeWeight: strokeWeight,
      fillColor: color,
      fillOpacity: fillOpacity,
      map: mapObject,
      center: { lat: latitude, lng: longitude },
      radius: radius
    });
  }

  deleteMapElement(element) {
    if (element) {
      element.setMap(null);
    }
  }

  generate24hrsOpeningHours() {
    let openingHours = [];
    for (let i = 0; i < weekDays.length; i++) {
      let opeingHour = {
        open: {
          day: weekDays[i].id,
          time: '0000'
        },
        close: {
          day: weekDays[i].id,
          time: '2359'
        }
      }
      openingHours.push(opeingHour);
    }
    return this.convertOpeningHoursToDXFormate(openingHours);
  }

  convertOpeningHoursToDXFormate(workingHours) {
    let hours = {}, OperatingHours = [];
    if (workingHours.length > 0) {
      weekDays.forEach(x => {
        hours[x.id] = null;
      });
      workingHours.forEach(x => {
        let day = hours[x.open.day];
        if (!day) {
          day = {};
          day.startDateTime =  x.open && x.open.time;
          day.endDateTime = x.close && x.close.time || '2359'; // if close time does exists then its 24hrs open so we need to set default time.
        } else {
          if (day.startDateTime > x.open.time) {
            day.startDateTime = x.open.time;
          }
          if (day.endDateTime < x.close.time) {
            day.startDateTime = x.close.time;
          }
        }
        hours[x.open.day] = day;
      })
    }
    Object.entries(hours).forEach(([key, value]) => {
      if (value) {
        OperatingHours.push({
          dayOfWeek: key,
          openingTime: moment.utc(value.startDateTime, 'HHmm').format('YYYY-MM-DDTHH:mm'),
          closingTime: moment.utc(value.endDateTime, 'HHmm').format('YYYY-MM-DDTHH:mm')
        })
      }
    });
    return OperatingHours;
  }
}